import Image from 'next/image';
import React from 'react';

import { Flex } from '@/box/components/Box.component';
import { useTranslation } from '@/i18n';
import { BodySmall } from '@/ui/typography';

interface MembershipSavingProps {
  saving: string | React.ReactNode;
  className?: string;
}

export const MembershipSaving = ({
  saving,
  className,
}: MembershipSavingProps) => {
  const { t } = useTranslation('bookingMembership');

  return (
    <Flex gap="6px" className={className}>
      <Image src="/icons/price-tag.svg" width={21} height={21} alt="" />
      <BodySmall
        uppercase
        css={{
          color: '#143C21',
          fontWeight: 400,
        }}
      >
        {t('card.membershipSaving')}
      </BodySmall>
      <BodySmall css={{ fontWeight: 'bold', color: '#143C21' }}>
        {saving}
      </BodySmall>
    </Flex>
  );
};
